// Phase 19.15 — "Test as User" sandbox.
// Lightweight client-side impersonation: stores the target user id in
// localStorage and an axios interceptor appends ?preview_as_user_id={id}
// to every /api request. Backend `get_current_user` honours the override
// only when the bearer is an office_manager in the same tenant.
import axios from "axios";

const STORAGE_KEY = "preview_as_user_id";
const STORAGE_TARGET = "preview_as_target";

let installed = false;

export const getImpersonationId = () => localStorage.getItem(STORAGE_KEY) || null;

export const getImpersonationTarget = () => {
  try {
    const raw = localStorage.getItem(STORAGE_TARGET);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const startImpersonation = (target) => {
  localStorage.setItem(STORAGE_KEY, target.id);
  localStorage.setItem(STORAGE_TARGET, JSON.stringify(target));
};

export const exitImpersonation = () => {
  localStorage.removeItem(STORAGE_KEY);
  localStorage.removeItem(STORAGE_TARGET);
};

// Install once on app boot.
export const installImpersonationInterceptor = () => {
  if (installed) return;
  installed = true;
  axios.interceptors.request.use((config) => {
    const id = getImpersonationId();
    if (!id) return config;
    // Only target our own API.
    const apiHost = process.env.REACT_APP_BACKEND_URL || "";
    if (!config.url) return config;
    const isOurApi = config.url.startsWith(apiHost) || config.url.startsWith("/api");
    if (!isOurApi) return config;
    config.params = { ...(config.params || {}), preview_as_user_id: id };
    return config;
  });
};
